import SolicitacaoCursoEventoMatricular from './componentes/SolicitacaoCursoEventoMatricular.vue';
import SolicitacaoCursoEventoMatricularLista from './componentes/SolicitacaoCursoEventoMatricularLista.vue';
import SolicitacaoCursoEventoMatricularForm from './componentes/SolicitacaoCursoEventoMatricularForm.vue'
export default {
  path: '/solicitacao-curso-evento-matricular',
  component: SolicitacaoCursoEventoMatricular,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoCursoEventoMatricularLista,
      name: 'solicitacao-curso-evento-matricular',
    },
    {
      path: ':idCript',
      component: SolicitacaoCursoEventoMatricularForm,
      name: 'solicitacao-curso-evento-matricular.editar'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-curso-evento-matricular/rotas.js